import { useEffect } from "react";
import { Modal, Form, Input, Switch, Button, Row, Col, Typography, Tag } from "antd";

const { Text } = Typography;

const EditProviderModal = ({ visible, loading, provider, onSubmit, onClose }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && provider) {
      form.setFieldsValue({
        name: provider.name ?? "",
        api_key: "",
        enabled: provider.enabled ?? true,
      });
    }
  }, [visible, provider, form]);

  const handleFinish = (values) => {
    const payload = {
      name: values.name?.trim(),
      enabled: values.enabled,
    };
    const apiKey = values.api_key?.trim();
    if (apiKey) {
      payload.api_key = apiKey;
    }
    onSubmit(payload);
  };

  const handleAfterClose = () => {
    form.resetFields();
  };

  return (
    <Modal
      title={
        <span>
          Edit Provider —{" "}
          <Tag style={{ textTransform: "lowercase" }}>{provider?.provider_key}</Tag>
        </span>
      }
      open={visible}
      onCancel={onClose}
      afterClose={handleAfterClose}
      footer={null}
      destroyOnClose
      width={640}
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item
              label="Display Name"
              name="name"
              rules={[{ required: true, message: "Name is required" }]}
            >
              <Input placeholder="e.g. OpenAI Primary" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Enabled" name="enabled" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Rotate API Key"
          name="api_key"
          extra={
            <Text type="secondary" style={{ fontSize: 12 }}>
              Leave blank to keep the current key.{" "}
              {provider?.api_key_masked && (
                <>
                  Current: <Text code>{provider.api_key_masked}</Text>
                </>
              )}
            </Text>
          }
        >
          <Input.Password placeholder="Enter new key to rotate" autoComplete="new-password" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Save Changes
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditProviderModal;
